import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import Qualified from "../../assets/img/png/10013.png";
import Personal from "../../assets/img/png/10015.png";
import Honesty from "../../assets/img/png/10014.png";
import Quality from "../../assets/img/png/10012.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsersCog,
  faHandshake,
  faBalanceScale,
  faMedal,
} from "@fortawesome/free-solid-svg-icons";

export const WhyChooseUs = () => {
  const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const reasons = [
    {
      image: Qualified,
      icon: faUsersCog,
      title: "Equipe qualificada",
      description:
        "Contamos com profissionais experientes e certificados, comprometidos com a excelência no atendimento.",
    },
    {
      image: Personal,
      icon: faHandshake,
      title: "Atendimento personalizado",
      description:
        "Entendemos as necessidades de cada cliente e oferecemos soluções sob medida.",
    },
    {
      image: Honesty,
      icon: faBalanceScale,
      title: "Transparência e honestidade",
      description:
        "Fornecemos orçamentos claros e sem surpresas, garantindo que você saiba exatamente o que esperar.",
    },
    {
      image: Quality,
      icon: faMedal,
      title: "Compromisso com a qualidade",
      description:
        "Empregamos apenas peças e equipamentos de primeira linha, assegurando a durabilidade e excelência dos nossos serviços.",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 4, md: 8 },
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mb: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h1"
          sx={{
            textAlign: "center",
            mb: { xs: 4, md: 8 },
            fontWeight: "bold",
            color: theme.palette.text.primary,
          }}
        >
          Por que escolher a Clima Tropical?
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: 4,
          }}
        >
          {reasons.map((reason, _index) => (
            <Card
              sx={{
                
                minHeight: 70 + 80 + 16 + 16, // altura mínima para acomodar o conteúdo
                //height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                padding: 3,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                transition: "all 0.3s ease-in-out",
                
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: theme.shadows[6],
                  borderColor: theme.palette.primary.main,
                },
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                  minHeight: 100,
                  p: 0,
                  "&:last-child": {
                    pb: 0,
                  },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: "white",
                    borderRadius: "50%",
                    width: 80,
                    height: 80,
                    minWidth: 60,
                    fontSize: "2rem",
                    objectFit: "contain",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    flexShrink: 0,
                  }}
                >
                  <FontAwesomeIcon icon={reason.icon} color="white" />
                </Box>

                <Typography
                  variant="h6"
                  component="h4"
                  sx={{
                    mb: 2,
                    fontWeight: "bold",
                    color: theme.palette.primary.main,
                    fontSize: "1.1rem",
                  }}
                >
                  {reason.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                  }}
                >
                  {reason.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};
